/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import CalculateIcon from "@mui/icons-material/Calculate";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import PersonIcon from "@mui/icons-material/Person";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";

import * as React from "react";
import { Select, MenuItem } from "@mui/material";
import { useAuthState } from "react-firebase-hooks/auth";

import { useEffect, useState } from "react";
import "./style.css";
import "./style.scss";

// react-router-dom components
import { NavLink, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import List from "@mui/material/List";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { LanguageContext } from "App";
import { UserContext } from "App";
import { getAuth, signOut } from "firebase/auth";
import { useContext } from "react";
// Material Dashboard 2 React context
import {
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  useMaterialUIController,
} from "context";
import BrandingTheme from "BrandingTheme";
import zIndex from "@mui/material/styles/zIndex";
import UsersApi from "Classes/API/UsersApi";
import TenantManager from "Classes/API/TenantManager";
import { jwtDecode } from "jwt-decode";
import TenantsApi from "Classes/API/Administration/TenantsApi";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const location = useLocation();
  const collapseName = location.pathname.replace("/", " ");
  const User = useContext(UserContext);
  const createMultiPackagePath = "/Accountingsessions/Packages/CreateMultiPackage";
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [language, setLanguage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const LanguageDropdown = ({ language, setLanguage, sidenavColor }) => {
    const handleLanguageChange = (event) => {
      setLanguage(event.target.value);
    };
  };
  const auth = getAuth();
  const [tenants, setTenants] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [isReady, setIsReady] = useState(false);
  const [branding, setBRanding] = useState();

  let tenantObj = tenants.find(
    (tenant) => tenant.id === TenantManager.getTenant(UsersApi.GetToken())
  );
  let displayTenantName = tenantObj ? tenantObj.name : "Unknown Tenant";

  const [decoded, setDecoded] = useState("");
  useEffect(() => {
    if (decoded?.tenant) {
      setIsReady(true);
    }
  }, [decoded]);

  useEffect(() => {
    if (user) setBRanding(new BrandingTheme(TenantManager.getTenant(UsersApi.GetToken())));
  }, [user]);

  useEffect(() => {
    const fetchTenants = async () => {
      if (!User?.id) return;
      const decodedd = jwtDecode(user.accessToken);
      if (decodedd?.tenant === "superadmin") {
        setDecoded(decodedd?.tenant);
      }

      try {
        const result = await TenantsApi.GetTenants();

        if (Array.isArray(result.data)) {
          setTenants(
            result.data.map((tenant) => ({
              id: tenant.tenantId,
              name: tenant.name,
            }))
          );
        } else {
          console.error("API did not return an array:", result);
          setTenants([]);
        }
      } catch (error) {
        console.log("-------------------fetched data" + error);
        console.error("Error fetching tenants:", error);
        setTenants([]);
      }
    };

    fetchTenants();
  }, [User]);

  const handleSubmit = async () => {
    if (!selectedTenant) {
      console.error("No tenant selected!");
      return;
    }

    const token = UsersApi.GetToken();
    TenantManager.setTenant(selectedTenant);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    window.location.reload();
  };

  let textColor = "white";

  const Logout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        <Navigate to="/" />;
      })
      .catch((error) => {
        // An error happened.
      });
  };
  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
    switchLanguage(selectedLanguage);
  };

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }
  const childRoutes5 = [
    "/Appointments/Feedback",
    "/Appointments/FeedbackStatistics",
    "/Appointments/UserStatistics",
    "/Appointments/AccountingSessionsStatistics",
    "/AccountingEntriesStatistics",
  ];
  useEffect(() => {
    if (childRoutes5.includes(location.pathname)) {
      setOpen5(true);
    }
  }, [location.pathname]);
  const childRoutes2 = [
    "/Appointments",
    "/PatientPrograms/CreatePatientProgram",
    "/PatientPrograms/ManagePatientPrograms",
    "/Appointments/PatientAppointmentRequests",
  ];
  useEffect(() => {
    if (childRoutes2.includes(location.pathname)) {
      setOpen2(true);
    }
  }, [location.pathname]);
  const childRoutes3 = [
    "/Accountingsessions",
    "/DomesticStays/CreateDomesticStay",
    "/Contracts/CreateContract",
    "/Accountingsessions/Packages/CreateMultiPackage",
  ];
  useEffect(() => {
    if (childRoutes3.includes(location.pathname)) {
      setOpen3(true);
    }
  }, [location.pathname]);
  const childRoutes0 = ["/PatientList", "/CreateUser"];
  useEffect(() => {
    if (childRoutes0.includes(location.pathname)) {
      setOpen0(true);
    }
  }, [location.pathname]);
  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const [open0, setOpen0] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);

  const handleClick = () => {
    setOpen0(false);
    setOpen(!open);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
  };
  const handleClick2 = () => {
    setOpen0(false);
    setOpen(false);
    setOpen2(!open2);
    setOpen3(false);
    setOpen5(false);
  };
  const handleClick3 = () => {
    setOpen0(false);
    setOpen(false);
    setOpen2(false);
    setOpen5(false);
    setOpen3(!open3);
  };
  const handleClick0 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
    setOpen0(!open0);
  };

  const handleClick5 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen0(false);
    setOpen5(!open5);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      setLanguage(storedLanguage);
    }
  }, []);
  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }
    //Tenants Dropdown List

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);
    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, href, route }) => {
    let returnValue;

    if (type === "collapse") {
      returnValue = href ? (
        <Link
          href={href}
          key={key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink key={key} to={route}>
          <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
        </NavLink>
      );
    } else if (type === "title") {
      returnValue = (
        <MDTypography
          key={key}
          color={textColor}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </MDTypography>
      );
    } else if (type === "divider") {
      returnValue = (
        <Divider
          key={key}
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
      );
    }

    return returnValue;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? 1 : 0)); // Toggle between 0 and 1
    }, 30000); // Switch every 5 seconds

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      id="TheSidenav"
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <div className="brandContainer">
          <div
            className="slider"
            style={{
              transform: `translateX(${currentIndex === 0 ? "0%" : "-100%"})`, // Slide based on index
            }}
          >
            <div
              className="brandItem"
              onClick={() => navigate("/")} // Navigate to home on click
              style={{ cursor: "pointer" }} // Optional: add pointer cursor for better UX
            >
              {/* Sub-Brand Logo and Name */}
              <img
                style={{ width: "60px", height: "60px" }}
                src={branding?.tenantLogo}
                alt="Sub Brand"
              />
              <h6 style={{ width: "100%", textAlign: "center", overflow: "hidden" }}>
                {branding?.tenantName}
              </h6>
            </div>

            <div
              className="brandItem"
              onClick={() => navigate("/")} // Navigate to home on click
              style={{ cursor: "pointer" }} // Optional: add pointer cursor for better UX
            >
              {/* Main Brand Logo and Name */}
              <img
                style={{ width: "100px", height: "40px" }}
                src={branding?.FullBrandLogo}
                alt="Main Brand"
              />
              <h6
                style={{ width: "100%", textAlign: "center", overflow: "hidden", fontSize: "17px" }}
              >
                {branding?.BrandName}
              </h6>
            </div>
          </div>
        </div>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />

      <List>
        {/* {renderRoutes} */}

        {/* start list */}

        {User.userType === "Patient" && (
          <>
            <Link
              type="button"
              className="activeLabel"
              component={NavLink}
              to="/PatientAccountingSessions/"
            >
              Sessions
            </Link>
            {/* <Link type="button" className="activeLabel" component={NavLink} to="/Users">Appointments</Link> */}
          </>
        )}
        {User.userType === "FloorManager" && (
          <>
            <Link
              type="button"
              className="activeLabel"
              component={NavLink}
              to="/AccountingSessions/"
            >
              Sessions
            </Link>
            <Link className="activeLabel" component={NavLink} to="/Appointments">
              Appointments
            </Link>
          </>
        )}
        {/* Users Management */}
        {(User.userType === "Admin" ||
          User.userType === "AppointmentEmployee" ||
          User.userType === "AccountingEmployee") && (
          <>
            <ListItemButton onClick={handleClick0}>
              <ListItemIcon className="header-logo">
                <PersonIcon />
              </ListItemIcon>
              <ListItemText className="headers">{translations.sidebarUsermanagement}</ListItemText>
              {open0 ? <ExpandLess className="indicator" /> : <ExpandMore className="indicator" />}
            </ListItemButton>

            <Collapse in={open0} timeout="auto" unmountOnExit>
              {/* <Link type="button" className="activeLabel" component={NavLink} to="/home"> Landing page</Link> */}
              <Link type="button" className="activeLabel" component={NavLink} to="/Users">
                {translations.sidebarChildernManageUsers}
              </Link>
              <Link type="button" className="activeLabel" component={NavLink} to="/CreateUser">
                {translations.sidebarChildernCreateUsers}
              </Link>
              <Link type="button" className="activeLabel" component={NavLink} to="/PatientList">
                {" "}
                {translations.sidebarChildernPatients}
              </Link>
            </Collapse>
          </>
        )}

        {/* administrations */}

        {(User.userType === "Admin" || User.userType === "SubAdmin") && (
          <>
            <ListItemButton onClick={handleClick}>
              <ListItemIcon className="header-logo">
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText className="headers" primary={translations.sidebarAdministration} />
              {open ? <ExpandLess className="indicator" /> : <ExpandMore className="indicator" />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
              {/* ------------------------  Employees -------------------------- */}
              {/* <Link
                type="button"
                className="activeLabel"
                component={NavLink}
                to="/EmployeeTypeList"
              >
                {" "}
                {translations.sidebarChildernAdministrationEmployeeTypes}
              </Link> */}

              {/* ------------------------  Therapists -------------------------- */}
              {/* <Link className="activeLabel" component={NavLink} to="/TherapistTypeList">
                {translations.sidebarChildernAdministrationTherapistTypes}
              </Link> */}

              {/* ------------------------  Facility tupes -------------------------- */}
              {/* <Link className="activeLabel" component={NavLink} to="/FacilityTypes">
                {translations.sidebarChildernAdministrationFacilityTypes}
              </Link> */}

              {/* ------------------------  Facilities-------------------------- */}
              {/* <Link className="activeLabel" component={NavLink} to="/Facilities">
                {translations.sidebarChildernAdministrationFacilities}
              </Link> */}

              {/* ------------------------  Sessions-------------------------- */}
              <Link className="activeLabel" component={NavLink} to="/Sessions">
                {translations.sidebarChildernAdministrationSessions}
              </Link>
            </Collapse>
          </>
        )}

        {User.userType === "Therapist" && (
          <>
            {/* <Link className="activeLabel" component={NavLink} to="/Accountingsessions">Accounting Sessions </Link> */}
            <Link className="activeLabel" component={NavLink} to="/PatientList">
              History Entries
            </Link>
          </>
        )}
        {(User.userType === "AppointmentEmployee" ||
          User.userType === "AccountingEmployee" ||
          User.userType === "Admin") && (
          <>
            {/* Accounting */}
            <ListItemButton onClick={handleClick3}>
              <ListItemIcon className="header-logo">
                <CalculateIcon />
              </ListItemIcon>
              <ListItemText className="headers" primary={translations.sidebarAccounting} />
              {open3 ? <ExpandLess className="indicator" /> : <ExpandMore className="indicator" />}
            </ListItemButton>

            <Collapse in={open3} timeout="auto" unmountOnExit>
              {/* ------------------------  Sessions-------------------------- */}
              <Link className="activeLabel" component={NavLink} to="/AccountingSessions/Single">
                {translations.sidebarChildernAccountingAccountingSessions}
              </Link>
              <Link className="activeLabel" component={NavLink} to="/AccountingSessions/Packages">
                {translations.sidebarChildernAccountingPackages}
              </Link>
              {User.userType != "AppointmentEmployee" && (
                <>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Accountingsessions/Packages/CreateMultiPackage"
                  >
                    {translations.sidebarChildernAccountingCreateMultiPackage}{" "}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/AccountingEntries/CreateNewEntry"
                  >
                    {translations.sidebarChildernAccountingCreateAccountingEntry}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/AccountingEntries/Table">
                    {translations.sidebarChildernAccountingAccountingEntriesTable}{" "}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/AccountingSessionWithNoPatientHistoryEntry"
                  >
                    {translations.sidebarChildernAccountingSessionsWithoutEntries}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/BalanceEntries/">
                    {translations.sidebarChildernAccountingUserBalanceEntries}{" "}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/DomesticStays/CreateDomesticStay"
                  >
                    {translations.sidebarChildernAccountingCreateInPatientStay}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/DomesticStays/Table">
                    {translations.sidebarChildernAccountingInPatientsStays}{" "}
                  </Link>

                  <Link className="activeLabel" component={NavLink} to="/Contracts/CreateContract">
                    {translations.sidebarChildernAccountingCreateContract}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/Contracts/Table">
                    {translations.sidebarChildernAccountingContractsTable}{" "}
                  </Link>
                </>
              )}
              {User.userType === "Admin" && (
                <>
                  <Link className="activeLabel" component={NavLink} to="/Logs">
                    {translations.sidebarChildernAccountingLogs}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/Analytics/Patients/">
                    {translations.sidebarChildernAccountingPatientAnalytics}{" "}
                  </Link>
                  <Link className="activeLabel" component={NavLink} to="/receipts">
                    {translations.sidebarChildernReceipts}{" "}
                  </Link>
                </>
              )}
            </Collapse>
          </>
        )}

        {(User.userType === "AppointmentEmployee" ||
          User.userType === "Admin" ||
          User.userType === "AccountingEmployee" ||
          User.userType === "Therapist" ||
          User.userType === "SubAdmin") && (
          <>
            {/* Appointments */}
            <ListItemButton onClick={handleClick2}>
              <ListItemIcon className="header-logo">
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText className="headers" primary={translations.sidebarAppointments} />
              {open2 ? <ExpandLess className="indicator" /> : <ExpandMore className="indicator" />}
            </ListItemButton>

            <Collapse in={open2} timeout="auto" unmountOnExit>
              <Link className="activeLabel" component={NavLink} to="/Appointments" end>
                {translations.sidebarChildernAppointmentsAppointments}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/PatientPrograms/CreatePatientProgram"
              >
                {translations.sidebarChildernAppointmentsCreatePatientProgram}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/PatientPrograms/ManagePatientPrograms"
              >
                {translations.sidebarChildernAppointmentsManagePatientPrograms}
              </Link>
              {/* <Link className="activeLabel" component={NavLink} to="/Appointments/CreateAppointment">Create Appointments</Link> */}
            </Collapse>
          </>
        )}
        {User.userType === "Admin" && (
          <>
            {/* Statistics */}
            <ListItemButton onClick={handleClick5}>
              <ListItemIcon className="header-logo">
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText className="headers" primary={translations.sidebarStatistics} />
              {open5 ? <ExpandLess className="indicator" /> : <ExpandMore className="indicator" />}
            </ListItemButton>

            <Collapse in={open5} timeout="auto" unmountOnExit>
              <Link className="activeLabel" component={NavLink} to="/Appointments/Feedback">
                {translations.sidebarChildernStatisticsCreateFeedback}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/FeedbackStatistics"
              >
                {translations.sidebarChildernStatisticsFeedbackStatistics}{" "}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/AccountingSessionsStatistics"
              >
                {" "}
                {translations.sidebarChildernStatisticsAccountingSessionsStatistics}
              </Link>
              <Link className="activeLabel" component={NavLink} to="/Appointments/UserStatistics">
                {translations.sidebarChildernStatisticsUsersStatistics}{" "}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/PackagesStatistics"
              >
                {translations.sidebarChildernStatisticsPackagesStatistics}{" "}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/AccountingSessionsPackagesStatistics"
              >
                {translations.sidebarChildernStatisticsPackagesStatistics2}
              </Link>
              <Link className="activeLabel" component={NavLink} to="/AccountingEntriesStatistics">
                {" "}
                {translations.sidebarChildernStatisticsAccountingEntriesStatistics}{" "}
              </Link>
            </Collapse>
          </>
        )}
      </List>
      <MDBox display="flex" flexDirection="column" justifyContent="space-between" height="54vh">
        <MDBox mt="auto">
          <MDBox display="flex" justifyContent="flex-end" mr="-4" mt="auto">
            <MDBox component="a" href="https://thedevhouse.web.app/" target="_blank" className="">
              <MDBox
                width={!brandName && "100%"}
                sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
              >
                {brand && (
                  <MDBox
                    component="img"
                    src={branding?.BrandLogo}
                    alt="Brand"
                    width="3rem"
                    sx={{
                      marginBottom: "0.6rem",
                      position: "inhert",
                      width: "14rem",
                      marginRight: "-0.1rem",
                      Zindex: 9999,
                    }}
                  />
                )}
                {/*   <MDTypography
                  component="h6"
                  variant="button"
                  fontWeight="medium"
                  color={textColor}
                >
                  {BrandingTheme.BrandName}
                </MDTypography> */}
              </MDBox>
            </MDBox>
          </MDBox>

          <MDTypography variant="body" color="white" p={2}>
            Language
          </MDTypography>

          <select
            value={language}
            onChange={handleLanguageChange}
            style={{
              backgroundColor: "transparent", // Background color of the select box
              color: "white", // Ensures the selected value is white
              fontSize: "15px",
              borderRadius: "4px",
            }}
          >
            {" "}
            <option
              value="en"
              style={{ color: "black", backgroundColor: "white", fontSize: "15px" }}
            >
              English
            </option>
            <option
              value="ar"
              style={{ color: "black", backgroundColor: "white", fontSize: "15px" }}
            >
              Arabic
            </option>
          </select>

          {decoded === "superadmin" && (
            <MDBox p={1} mt="5px" width="100%">
              <MDBox width="100%" textAlign="center">
                <label style={{ color: "white", fontSize: "15px" }}>{displayTenantName}</label>
              </MDBox>
              <MDBox width="100%">
                <select
                  value={selectedTenant}
                  onChange={(e) => setSelectedTenant(e.target.value)}
                  style={{ width: "100%", padding: "8px", fontSize: "15px" }} // Ensuring full width
                >
                  <option value="">--Select a tenant</option>
                  {Array.isArray(tenants) &&
                    tenants.map((tenant) => (
                      <option key={tenant.id} value={tenant.id}>
                        {tenant.name}
                      </option>
                    ))}
                </select>
              </MDBox>

              <MDBox mt={1} width="100%">
                <MDButton onClick={handleSubmit} disabled={!selectedTenant} fullWidth>
                  Submit
                </MDButton>
              </MDBox>
            </MDBox>
          )}

          <MDBox p={1} mt="auto">
            <MDButton
              component="a"
              target="_blank"
              rel="noreferrer"
              sx={{
                backgroundColor: "#3560AD",
                color: "white !important", // Force white text
                "&:hover": {
                  backgroundColor: "#4682B4",
                  color: "white !important", // Keep white text on hover
                },
              }}
              fullWidth
              onClick={Logout}
            >
              {translations.sidebarLogOutBtn}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
